import { differenceInMinutes, startOfDay } from 'date-fns';
import { minutesInHour } from 'helpers/timeConsts';
import { TFunction } from 'react-i18next';

interface GetDifferenceDateStartProps {
  date: Date | null;
  dateFrom: Date;
  timeString: string;
  t: TFunction;
}

const getDifferenceFromDateStart = ({
  date,
  dateFrom,
  timeString,
  t,
}: GetDifferenceDateStartProps) => {
  const [hours, minutes] = timeString.split(':').map(Number);
  if (!date) {
    return '';
  }

  const currentDate = startOfDay(date);
  currentDate.setHours(hours, minutes, 0, 0);
  const minutesDuration = differenceInMinutes(currentDate, dateFrom);

  const durationHours = Math.floor(minutesDuration / minutesInHour);
  const durationMinutes = minutesDuration % minutesInHour;

  if (durationMinutes === 0) {
    return t('project_tracking.hours_duration', { hours: durationHours });
  }

  if (durationHours === 0) {
    return t('project_tracking.min_duration', { minutes: durationMinutes });
  }

  return t('project_tracking.hours_min_duration', {
    hours: durationHours,
    minutes: durationMinutes,
  });
};

export default getDifferenceFromDateStart;
